import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IBunkerFuelTableRow } from "redux/app/vdmdashboard/@types";
import { IStore } from "redux/store";

const getDateBadgeClass = (color: string) => {
	switch (color) {
		case "red":
			return "bg-red-100 text-red-700";
		case "green":
			return "bg-green-100 text-green-700";
		default:
			return "bg-gray-100 text-gray-700";
	}
};

type OwnProps = {
	fuelType: string;
	tableData: IBunkerFuelTableRow[];
};
type BunkerFuelTableProps = PropsFromRedux & OwnProps;
function BunkerFuelTable(props: BunkerFuelTableProps) {
	const { fuelType, tableData } = props;

	const totalCapacity = tableData
		.filter((item) => !isNaN(parseFloat(item.capacity)))
		.reduce((sum, item) => sum + parseFloat(item.capacity), 0)
		.toFixed(2);

	const totalCurrentVolume = tableData
		.reduce((sum, item) => sum + parseFloat(item.currentVolume), 0)
		.toFixed(2);

	return (
		<>
			<div className="p-4 bg-white rounded-lg ">
				<h2 className="text-center text-base font-medium bg-blue-100 text-blue-500 py-1.5 rounded-t border border-gray-300 border-b-none">
					{fuelType}
				</h2>

				<div className="overflow-x-auto border border-b-none border-gray-300 rounded-b">
					<table className="min-w-full divide-y divide-gray-200 border-b-none rounded-b">
						<thead className="bg-gray-50">
							<tr>
								<th
									scope="col"
									className="px-4 py-3 text-left text-[12px] font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
								>
									Tank Type
								</th>
								<th
									scope="col"
									className="px-4 py-3 text-left text-[12px] font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
								>
									Capacity (MT)
								</th>
								<th
									scope="col"
									className="px-4 py-3 text-left text-[12px] font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
								>
									Current Volume
								</th>
								<th
									scope="col"
									className="px-4 py-3 text-left text-[12px] font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
								>
									Sulphur %
								</th>
								<th
									scope="col"
									className="px-4 py-3 text-left text-[12px] font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
								>
									Last Bunker Location
								</th>
								<th
									scope="col"
									className="px-4 py-3 text-left text-[12px] font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
								>
									Last Bunker Date
								</th>
								<th
									scope="col"
									className="px-4 py-3 text-left text-[12px] font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
								>
									Status
								</th>
							</tr>
						</thead>

						<tbody className="bg-white divide-y divide-gray-200">
							{tableData.map((row, index) => (
								<tr key={index} className="hover:bg-gray-50">
									<td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700 border-gray-300 border-r">
										{row.tankType}
									</td>
									<td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700 border-gray-300 border-r text-left">
										{row.capacity}
									</td>
									<td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700 border-gray-300 border-r text-left">
										{row.currentVolume}
									</td>
									<td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700 border-gray-300 border-r text-left">
										{row.sulphur}
									</td>
									<td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700 border-gray-300 border-r">
										{row.lastBunkerLocation}
									</td>
									<td className="px-4 py-2 whitespace-nowrap text-sm border-gray-300 border-r">
										<span
											className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium ${getDateBadgeClass(
												row.dateColor
											)}`}
										>
											<svg
												className="-ml-0.5 mr-1 h-2 w-2"
												fill="currentColor"
												viewBox="0 0 8 8"
											>
												<circle cx="4" cy="4" r="3" />
											</svg>
											{row.lastBunkerDate}
										</span>
									</td>
									<td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
										{row.status !== "-" ? (
											<span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-blue-100 text-blue-700">
												<svg
													className="-ml-0.5 mr-1 h-2 w-2 text-blue-400"
													fill="currentColor"
													viewBox="0 0 8 8"
												>
													<circle cx="4" cy="4" r="3" />
												</svg>
												{row.status}
											</span>
										) : (
											<span>{row.status}</span>
										)}
									</td>
								</tr>
							))}
						</tbody>

						<tfoot className="bg-gray-50">
							<tr>
								<td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
									Total
								</td>
								<td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-left">
									{totalCapacity}
								</td>
								<td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-left">
									{totalCurrentVolume}
								</td>

								<td className="px-4 py-2"></td>
								<td className="px-4 py-2"></td>
								<td className="px-4 py-2"></td>
								<td className="px-4 py-2"></td>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>
		</>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BunkerFuelTable);
